module.exports = __webpack_public_path__ + "static/img/dzbl.6cfb0a51.png";